import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormErrorPipe } from './form-error.pipe';
import { ReportStatusPipe } from './report-status.pipe';

@NgModule({
  declarations: [FormErrorPipe, ReportStatusPipe],
  imports: [CommonModule],
  exports: [FormErrorPipe, ReportStatusPipe],
})
export class PipesModule {}
